import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Pin({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Pin.Outline {...props} /> : <Pin.Solid {...props} />;
}

Pin.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M14.7743 12.5282L15.2625 14.3493L14.596 15.5037L11.7092 13.837L9.7097 17.3002L8.7991 17.5441L8.555 16.6336L10.5545 13.1703L7.66775 11.5037L8.33425 10.3493L10.1555 9.86152L12.4882 5.82108L11.9109 5.48775L12.5774 4.33333L18.3509 7.66667L17.6844 8.82108L17.107 8.48775L14.7743 12.5282ZM9.9797 11.2993L13.617 13.3993L13.3363 12.3521L15.9523 7.82108L13.6429 6.48775L11.0269 11.0188L9.9797 11.2993Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Pin.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M14.846 12.6L15.3342 14.421L14.6677 15.5755L11.781 13.9088L9.78148 17.372L8.87088 17.6159L8.62678 16.7054L10.6263 13.2421L7.73953 11.5755L8.40603 10.421L10.2272 9.9333L12.56 5.89286L11.9826 5.55952L12.6491 4.40511L18.4226 7.73844L17.7561 8.89286L17.1788 8.55952L14.846 12.6Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
